define('views/modules/dashboard/goal/list/goal-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/dashboard/goal/list/goal-list-item',
    'views/parts/chart/double-doughnut-chart'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VGoalListItem,
    VDoubleDoughnutChart
) {

    var VGoalList = VList.extend({
        item: VGoalListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['profile', 'url', 'group']));
        },
    });

    return VGoalList;

});

